import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "less",
  "use": "less-usage",
  "viewBox": "0 0 26.2 26.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26.2 26.2\" id=\"less\"><path fill=\"none\" stroke-width=\"3\" stroke-miterlimit=\"10\" d=\"M26.2 13.1H0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol